import InfoIcon from "@redotech/redo-icons/info-circle_filled.svg";
import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoIcon } from "../../../../arbiter-components/icon/redo-icon";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { RedoExternalLink } from "../../../../arbiter-components/links/redo-external-link";
import { Flex } from "../../../../flex";
import { Text } from "../../../../text";

export const RoyalMailCarrierInput = groupInput({
  accountNumber: input<string>({ validator: nonEmptyValidator }),
  postingLocationNumber: input<string>({ validator: nonEmptyValidator }),
  username: input<string>({ validator: nonEmptyValidator }),
});

export type RoyalMailCarrierValue = InputSchema.Value<
  typeof RoyalMailCarrierInput
>;

export type RoyalMailCarrierForm = InputSchema.Input<
  typeof RoyalMailCarrierInput
>;

export const royalMailCarrierDefault = (): RoyalMailCarrierValue => ({
  accountNumber: "",
  postingLocationNumber: "",
  username: "",
});

export const CreateRoyalMailCarrierForm = memo(
  function CreateRoyalMailCarrierForm({
    carrierInput,
  }: {
    carrierInput: RoyalMailCarrierForm;
  }) {
    return (
      <>
        <Flex align="center" gap="sm" mb="lg">
          <RedoIcon color="tertiary" Icon={InfoIcon} size={16} />
          <Flex align="flex-start" flexDirection="column" gap="xs">
            <Text fontSize="xs" textColor="secondary">
              After creating this account, manual onboarding is required.
            </Text>
            <RedoExternalLink
              text="EasyPost onboarding guide"
              url="https://docs.easypost.com/carriers/royal-mail-guide"
            />
          </Flex>
        </Flex>
        <RedoTextInput
          label="Account Number"
          placeholder="If unknown, contact a Royal Mail representative"
          setValue={carrierInput.inputs.accountNumber.setValue}
          value={carrierInput.inputs.accountNumber.value}
        />
        <RedoTextInput
          label="Posting Location Number"
          placeholder="10-digit number starting with 90, available from Royal Mail"
          setValue={carrierInput.inputs.postingLocationNumber.setValue}
          value={carrierInput.inputs.postingLocationNumber.value}
        />
        <RedoTextInput
          label="Email"
          placeholder="Email registered with the Royal Mail account"
          setValue={carrierInput.inputs.username.setValue}
          value={carrierInput.inputs.username.value}
        />
      </>
    );
  },
);
